import { Navigate } from "react-router-dom"
import { useEnrollments } from "utils/hooks/useEnrollments"

import Classes, { CLASSES_SECTION_ID } from "."

/**
 * Email notifications for live classes link to a generic
 * `/<itemType>/<itemSlug>/classes` URL for every learning item type.
 *
 * Courses don't have a dedicated classes tab in the new delivery mode, so send
 * those learners to the classes section on the overview page instead.
 */
const CourseClassesRoute = () => {
  const {
    pgctl: { isNewDeliveryMode },
  } = useEnrollments()

  if (isNewDeliveryMode)
    return (
      <Navigate
        replace
        to={`../overview?highlight-element-id=${CLASSES_SECTION_ID}`}
      />
    )

  return <Classes />
}

export default CourseClassesRoute
